import { Suspense, useEffect, useMemo } from "react";
import '@/views/language/i18n'; // Import i18n configuration dịch ngôn ngữ
import { ThemeProvider } from "@mui/material";
import { BrowserRouter } from "react-router-dom";
import ComponentShareWrapper from './ComponentShareWrapper';
import dark from "./theme/dark";
import light from "./theme/light";
import GlobalStyles from '@mui/material/GlobalStyles';
import RobotoFontVar from '../views/assets/fonts/Roboto-VariableFont.ttf';
import { useGetLanguage, useGetTheme } from "@/controllers/gridManager/appManager/appManager";
import { useTranslation } from "react-i18next";
import useIsMobile from "./hooks/useIsMobile";

export default function MainApp(props: any) {
    const { theme } = useGetTheme()
    const { i18n } = useTranslation()
    const { language } = useGetLanguage()
    const matches = useIsMobile();

    const globalStyles = useMemo(() => {
        return {
            '@font-face': [
                {
                    fontFamily: 'Roboto',
                    src: `url(${RobotoFontVar}) format('truetype')`,
                    fontWeight: '400,500,600,700',
                    fontStyle: 'normal',
                },
            ],
            '#content-app2': {
                fontFamily: 'Roboto, Arial, sans-serif',
                fontSize: "14px",
                fontWeight: 400,
                overflow: matches ? "auto" : "unset"
            },
            '.Mui-disabled': {
                pointerEvents: "unset !important",
                cursor: "not-allowed !important"
            }
        };
    }, [matches])

    useEffect(() => {
        i18n.changeLanguage(language)
    }, [language])

    const themeMode = theme === 'dark' ? dark : light;
    return (
        <ThemeProvider theme={theme === 'dark' ? dark : light}>
            <GlobalStyles styles={globalStyles} />
            <div className="App" style={{ background: themeMode.palette.background.main, color: themeMode.palette.text.primary }}>
                <BrowserRouter>
                    <Suspense fallback={<>loading...</>}>
                        <ComponentShareWrapper {...props} />
                    </Suspense>
                </BrowserRouter>
            </div>
        </ThemeProvider >
    );
}
